import { render } from "./DocumentosAnalise.vue?vue&type=template&id=5d29dc43"
import script from "./DocumentosAnalise.vue?vue&type=script&lang=js"
export * from "./DocumentosAnalise.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__